var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79086 1.79086 0 4 0H16C18.2091 0 20 1.79086 20 4V16C20 18.2091 18.2091 20 16 20H4C1.79086 20 0 18.2091 0 16V4Z",
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.1485 5.22274C17.3967 5.47258 17.575 5.78325 17.6655 6.12364C18 7.38 18 10 18 10C18 10 18 12.62 17.6655 13.8764C17.575 14.2168 17.3967 14.5274 17.1485 14.7773C16.9002 15.0271 16.5907 15.2074 16.2509 15.3C15 15.6364 10 15.6364 10 15.6364C10 15.6364 5 15.6364 3.74909 15.3C3.40929 15.2074 3.09977 15.0271 2.85153 14.7773C2.60328 14.5274 2.425 14.2168 2.33455 13.8764C2 12.62 2 10 2 10C2 10 2 7.38 2.33455 6.12364C2.425 5.78325 2.60328 5.47258 2.85153 5.22274C3.09977 4.9729 3.40929 4.79264 3.74909 4.7C5 4.36364 10 4.36364 10 4.36364C10 4.36364 15 4.36364 16.2509 4.7C16.5907 4.79264 16.9002 4.9729 17.1485 5.22274ZM12.5455 10L8.36365 7.62093V12.3791L12.5455 10Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuYoutube);
export default __webpack_public_path__ + "static/media/menu-youtube.545789754fc4411ec4e72e7ca9c39c16.svg";
export { ForwardRef as ReactComponent };